import { Reducer } from "redux";

import { NPPESDataResponse } from "../models/Api/PhysicianDetails";
import { nppesInitialRecord } from "../constants/PhysicianDetails";
import { GetNPPESDataActionDispatchTypes } from "../constants/Nppes";
import { NppesSearchDispatchTypes } from "../models/DispatchTypes/Nppes";

const initialState: NPPESDataResponse = {
  loading: true,
  response: nppesInitialRecord
};

const NppesDetailsDataReducer: Reducer<
NPPESDataResponse,
NppesSearchDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetNPPESDataActionDispatchTypes.GET_NPPES_DATA_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetNPPESDataActionDispatchTypes.GET_NPPES_DATA_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetNPPESDataActionDispatchTypes.GET_NPPES_DATA_RESET: {
      return initialState;
    }
    case GetNPPESDataActionDispatchTypes.GET_NPPES_DATA_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default NppesDetailsDataReducer;
